import { useMemo, type ReactNode } from "react";
import { shortProductName } from "@/features/orders/statusMap";
import { useProductNameMap } from "./catalogApi";
import { ProductLabelContext, type ProductLabelFn } from "./productLabelContext";

/**
 * Phát hàm tra nhãn gói theo danh mục máy chủ (`/products`, đủ mọi thương hiệu,
 * kể cả gói ngừng bán) cho cả cây bên dưới. Danh mục chưa về / lỗi thì
 * `useProductNameMap` trả bảng tĩnh dự phòng — không bao giờ tệ hơn trước.
 */
export function ProductLabelProvider({ children }: { children: ReactNode }) {
  const names = useProductNameMap();
  const label = useMemo<ProductLabelFn>(
    () => (code, opts) => {
      if (!code) return "";
      const full = names[code];
      if (!full) return code;
      return opts?.full ? full : shortProductName(full);
    },
    [names],
  );
  return <ProductLabelContext.Provider value={label}>{children}</ProductLabelContext.Provider>;
}
